import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import {setLookPageOpened} from "../../../actions/lookFunctions";
import LookUserHeader from "./lookUserHeader";
import LookUserLeftSide from "./lookUserLeftSide";
import {ROUTES} from "../../../routes";
import LookUserContent from "./lookUserContent";

const LookUser = (props) => {

  const {setLookPageOpened, history, location, hideOverlay} = props;

  const popupClose = () => {
    setLookPageOpened("");
    hideOverlay(() => {
      if (!window.location.hash.includes("look")) {   // fade out && router change after
        history.push(ROUTES.home);
      }
    });
  }

  const handleBackClick = () => {
    switch (location.pathname) {
      case ROUTES.login:
      default: {
        setLookPageOpened("");
        hideOverlay(() => {
          if (!window.location.hash.includes("look")) {   // fade out && router change after
            history.push(ROUTES.home);
          }
        });
        break;
      }
      case ROUTES.register: {
        setLookPageOpened(ROUTES.login);
        history.push(ROUTES.login);
        break;
      }
    }
  }

  return (
    <div className="ll">
      <div className="ll-body ll-body--user">
        <LookUserHeader onBackClick={handleBackClick}/>
        <div className="ll-user">
          <LookUserLeftSide/>
          <LookUserContent popupClose={popupClose}/>
        </div>
      </div>
    </div>
  )
};

const mapStateToProps = () => {
  return {

  };
};

const mapDispatchToProps = {
  setLookPageOpened
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LookUser)
)
